import React from 'react';
import {CardElement} from 'react-stripe-elements';
import {connect} from 'react-redux';
import {injectStripe} from 'react-stripe-elements';

class CardSection extends React.Component {

  handleChange = (e) => {
      if(!e.error)
      {
        this.props.stripe.createToken().then((resp) => {
        if(resp.token)
        {
          this.props.setHiddenToken(resp.token.id);
          this.props.onSuccess();
          this.props.resetError();
        }
      });
      }
      else
      {
        this.props.stripe.createToken();
        this.props.onError(e.error.message);
      }
  }
  render() {
    return (
        <CardElement
          style={{base: {fontSize: '12px', 
          color: '#32325d',
          'line-height': '18px',
          'font-family': "'Helvetica Neue', Helvetica, sans-serif",
          height: '18px',
         '-webkit-font-smoothing': 'antialiased'}}}
          onChange={this.handleChange}
          />
    );
  }
}
const mapStateToProps = ({ state }) => ({
});

export default connect(
  mapStateToProps, (dispatch, ownProps) => {
  return {
    onSuccess: () => dispatch({ type: 'TOKEN_SUCCESS' }),
    onError: (payload) => dispatch({ type: 'CARD_DETAILS_ERROR', payload }),
    resetError: () => dispatch({type: 'CARD_DETAILS_RESET_ERROR'})
  }}
)(injectStripe(CardSection));



// WEBPACK FOOTER //
// ./src/containers/NiceChoice/CardSection.js